import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchCustomTheme } from 'redux/themes/actions';

import { useTranslation } from 'react-i18next';

import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import './FontSelector.css';


function FontSelector(props) {
  const { me, patchCustomTheme, setCustomMode, fonts } = props;
  const customThemeId = me && me.custom_theme && me.custom_theme.id;
  const { t } = useTranslation();

  const [currentFont, setCurrentFont] = useState(me.custom_theme.font_style);

  return (
    <div className="appearance-font-selector__component">
      {fonts &&
        fonts.map(font => (
          <ProFeaturePlaceholder
            noKeyIcon
            placeholderContent={
              <div>
                {t("This font is available on the PRO plan.")}
              </div>
            }
            proLabel={font.pro}
            locked={
              me &&
              me.subscription &&
              !me.subscription.ff_add_fonts &&
              font.pro
            }
            key={`font-item-pro-feature-key-${font.className}`}
          >
            <div
              className={`font-style-item ${font.className}
              ${currentFont === font.fontFamily ?  ' active ': 'null'}`}
              onClick={() => {
                if (me.theme) {
                  setCustomMode();
                }
                const form = new FormData();
                form.append('font_style', font.fontFamily);
                patchCustomTheme(customThemeId, form);
                setCurrentFont(font.fontFamily);
              }}
              role="button"
              tabIndex={-1}
              style={{
                fontFamily: `${font.fontFamily}`,
              }}
            >
              {t("Link")}
            </div>
          </ProFeaturePlaceholder>
        ))}
    </div>
  );
}

FontSelector.propTypes = {
  patchCustomTheme: PropTypes.func.isRequired,
  setCustomMode: PropTypes.func.isRequired,
  me: PropTypes.object,
  fonts: PropTypes.object.isRequired,
};

FontSelector.defaultProps = {
  me: null,
};

const mapStateToProps = state => ({
  me: state.usersReducer.me,
});

export default connect(
  mapStateToProps,
  {
    patchCustomTheme,
  }
)(FontSelector);
